module.exports = __webpack_public_path__ + "img/murloc_fortress_small.90cbd160.png";